import { CompetencyLibrary, HandleCompLibrary } from 'components/types/company';

const customHooks = ({ initialValues } : CompetencyLibrary) => {
  const handleAddField = ({
    data, i, setFieldValue, setIsOpen,
  } : HandleCompLibrary) => {
    const newData = [...data];
    newData.splice(i + 1, 0, initialValues.tempData.competency_detail[0].detail[0]);
    const reOrder = newData.map((item, ix) => ({
      ...item,
      order: ix + 1,
    }));
    setFieldValue('tempData.competency_detail[0].detail', reOrder);
    setIsOpen(i + 1);
  };

  const handleRemoveField = ({ data, i, setFieldValue }: HandleCompLibrary) => {
    const newData = [...data];
    newData.splice(i, 1);
    const reOrder = newData.map((item, ix) => ({
      ...item,
      order: ix + 1,
    }));
    setFieldValue('tempData.competency_detail[0].detail', reOrder);
  };

  const emptyEvent = (e: string) => (e === '<p><br></p>' ? '' : e);

  const handleAddLevel = ({
    dataDetail, ix, i, setFieldValue, setIsOpen,
  }) => {
    const newData = [...dataDetail];
    const dataAdd = { ...initialValues.tempData.competency_detail[0].detail[0], order: i + 2 };
    newData.splice(i + 1, 0, dataAdd);
    setFieldValue(`data.competency_detail[${ix}].detail`, newData);
    setIsOpen(i + 1);
  };

  const handleDelLevel = ({
    detailId, ix, data, setFieldValue,
  }) => {
    const result = data.competency_detail[ix].detail.filter((item) => item.competency_detail_id !== detailId);
    setFieldValue(`data.competency_detail[${ix}].detail`, result);
  };

  return {
    handleAddField,
    handleRemoveField,
    emptyEvent,
    handleAddLevel,
    handleDelLevel,
  };
};

export default customHooks;
